import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Card } from './ui/card';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';
export function Reviews() {
  const reviews = [{
    quote: 'These guys are awesome. Texted a photo of my garage on Monday. Done by Tuesday afternoon. Cleaner than I left it.',
    name: 'Mike R.',
    location: 'Scottsdale',
    initial: 'M'
  }, {
    quote: 'The AZ Junk Nerds crew was professional, fast, and genuinely nice. Price was exactly what they quoted. No surprises.',
    name: 'Jessica L.',
    location: 'Chandler',
    initial: 'J'
  }, {
    quote: 'Called three other companies. The Nerds were the only ones who answered and showed up same day. Huge difference.',
    name: 'David P.',
    location: 'Phoenix',
    initial: 'D'
  }, {
    quote: "Hauled off an entire garage full of junk plus an old hot tub. Took half a day. I'm still stunned at how fast they worked.",
    name: 'Amanda K.',
    location: 'Mesa',
    initial: 'A'
  }, {
    quote: 'If you need junk gone, just call these guys. Seriously. No gimmicks, fair pricing, and they cleaned up after themselves.',
    name: 'Ryan T.',
    location: 'Gilbert',
    initial: 'R'
  }];
  return <section id="reviews" className="relative py-20 md:py-28 bg-navy" data-id="element-155">
      <div className="container mx-auto px-4" data-id="element-156">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12 md:mb-16" data-id="element-157">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white tracking-wider mb-4" data-id="element-158">
            WHAT PHOENIX SAYS ABOUT <span className="text-lime" data-id="element-159">THE NERDS</span>
          </h2>
          <div className="w-32 h-1 bg-lime mx-auto mb-6" data-id="element-160" />
          <div className="flex items-center justify-center gap-2 text-lg md:text-xl text-white/80" data-id="element-161">
            <div className="flex" data-id="element-162">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-163" />)}
            </div>
            <span data-id="element-164">Rated 5 stars across Google, Yelp, and Facebook.</span>
          </div>
        </motion.div>

        {/* Reviews Carousel */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-6xl mx-auto" data-id="element-165">
          <Carousel opts={{
          align: 'start',
          loop: true
        }} className="w-full" data-id="element-166">
            <CarouselContent className="-ml-4" data-id="element-167">
              {reviews.map((review, index) => <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3" data-id="element-168">
                  <Card className="bg-navy/50 border-2 border-lime/40 p-6 md:p-8 h-full hover:border-lime hover:shadow-[0_0_30px_rgba(163,230,53,0.3)] transition-all duration-300" data-id="element-169">
                    <div className="space-y-4" data-id="element-170">
                      {/* Stars */}
                      <div className="flex gap-1" data-id="element-171">
                        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-172" />)}
                      </div>

                      {/* Quote */}
                      <p className="text-white/90 leading-relaxed text-base min-h-[120px]" data-id="element-173">
                        "{review.quote}"
                      </p>

                      {/* Author */}
                      <div className="flex items-center gap-3 pt-4 border-t border-white/10" data-id="element-174">
                        <div className="w-10 h-10 rounded-full bg-lime/20 border-2 border-lime flex items-center justify-center" data-id="element-175">
                          <span className="font-heading text-lg text-lime" data-id="element-176">
                            {review.initial}
                          </span>
                        </div>
                        <div data-id="element-177">
                          <p className="text-white font-medium" data-id="element-178">
                            {review.name}
                          </p>
                          <p className="text-lime text-sm" data-id="element-179">{review.location}</p>
                        </div>
                      </div>
                    </div>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block" data-id="element-180">
              <CarouselPrevious className="border-lime/40 text-lime hover:bg-lime/10 -left-12" data-id="element-181" />
              <CarouselNext className="border-lime/40 text-lime hover:bg-lime/10 -right-12" data-id="element-182" />
            </div>
          </Carousel>
        </motion.div>
      </div>
    </section>;
}